/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../_metronic/helpers'
import {ProfileByUserModel} from '../../../../../model'
import {getProfileByUser, deleteProfileByUser, getSite, getCamp} from '../../../../../services'
import {useCentral} from '../../../../../../../hooks/useCentral'
import {ModalAddUser} from '../modal/ModalAddUser'
import Swal from 'sweetalert2'
import {ShowSnackBar} from '../../../../../../../util/functions'
import {useKhipu} from '../../../../../../../hooks/useKhipu'
import {
  useCamp,
  useClient,
  useCompany,
  useSite,
  useApplication,
  useProfile,
} from '../../../../../hooks'
const TablePermissionByUser: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    selectedOn,
    pagination,
    updateTableDetail,
    setUpdateTableDetail,
    clearTableDetail,
    setClearTableDetail,
    selected,
    clearSelected,
  } = useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [detailpermission, setDetailPermission] = useState<ProfileByUserModel | any>(null)
  const {searchValuesDetail, clearSearchValuesDetail} = useKhipu()
  const {siteList, getSiteList, handleClear: handleClearSite} = useSite()
  const {clientList, getClientList, handleClear: handleClearClient} = useClient()
  const {companyList, getCompanyList, handleClear: handleClearCompany} = useCompany()
  const {campList, getCampList, handleClear: handleClearCamp} = useCamp()
  const {module, getModuleList, handleClear: handleClearApplication} = useApplication()
  const {getProfileList, profiles} = useProfile()

  useEffect(() => {
    getCompanyList()
    getSiteList()
    getClientList()
    getCampList()
    getModuleList()
    getProfileList()
    return () => {
      clearSearchValuesDetail()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClear = () => {
    setIdPermission('')
    setDetailPermission(null)
  }
  const getProflieByUserList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getProfileByUser(
        {
          usuarioId: currentTabItem.idToEdit,
          ...searchValuesDetail,
        },
        pagination.currentPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const handleEdit = (item: ProfileByUserModel) => {
    if (item) {
      setDetailPermission(item)
      setIdPermission(item.id)
      setShowModalNew(true)
    }
  }
  useEffect(() => {
    getProflieByUserList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getProflieByUserList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    if (updateTableDetail) {
      if (pagination.currentPage === 1) {
        clearSelected()
        getProflieByUserList()
        // setSelectedBookings([])
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTableDetail(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTableDetail])

  useEffect(() => {
    if (clearTableDetail) {
      if (pagination.currentPage === 1) {
        clearSelected()
        getProflieByUserList()
        // setSelectedBookings([])
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTableDetail(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTableDetail])

  const columns: Column<ProfileByUserModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name='companiaId'
            selecteable
            data={companyList}
            fromDetail
          />
        ),
        accessor: 'compania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name='clienteId'
            selecteable
            data={clientList}
            fromDetail
          />
        ),
        accessor: 'cliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name='siteId'
            selecteable
            data={siteList}
            fromDetail
          />
        ),
        accessor: 'site',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='campamentoId'
            selecteable
            data={campList}
            fromDetail
          />
        ),
        accessor: 'campamento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Módulo'
            name='aplicacionId'
            selecteable
            data={module}
            fromDetail
          />
        ),
        accessor: 'aplicacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Perfil'
            name='perfilId'
            selecteable
            data={profiles}
            fromDetail
          />
        ),
        accessor: 'perfil',
      },

      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('PERMISO/EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleEdit(props.data[props.row.index])}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}{' '}
          </>
        ),
      },
    ],
    [companyList, clientList, siteList, campList, module, profiles, selectedOn],
  )

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const filter = data.filter((detail) => detail.id === selectedOn[0])
        let obj = {
          usuarioId: currentTabItem.idToEdit,
          perfilId: filter[0]?.perfilId,
          siteId: filter[0]?.siteId,
          campamentoId: filter[0]?.campamentoId,
          clienteId: filter[0]?.clienteId,
          companiaId: filter[0]?.companiaId,
        }

        const {data: response} = await deleteProfileByUser(obj)
        if (!response.error) {
          ShowSnackBar('Se eliminó satisfactoriamente')
          getProflieByUserList()
        } else {
          ShowSnackBar(response.message, 'error')
        }
        getProflieByUserList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setDetailPermission(null)
    setIdPermission('')
    setShowModalNew(true)
  }
  return (
    <>
      {isAllowed('PERMISO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('PERMISO/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('PERMISO/ELIMINAR') && (
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={selectedOn.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable
            data={data}
            columns={columns as any}
            classNameProps='dataTablecentral'
            fromDetail
          />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <ModalAddUser
            show={showModalNew}
            setShow={setShowModalNew}
            getProflieByUserList={getProflieByUserList}
            detailpermission={detailpermission}
            idPermission={idPermission}
            setIdPermissionList={handleClear}
          />
        </KTCard>
      )}
    </>
  )
}

const TablePermissionByUserWrapper = () => {
  return (
    <KTableProvider>
      <TablePermissionByUser />
    </KTableProvider>
  )
}
export {TablePermissionByUserWrapper}
